import { render, staticRenderFns } from "./IncludeDeletedClassificationsToggle.vue?vue&type=template&id=aee5f9da&"
import script from "./IncludeDeletedClassificationsToggle.vue?vue&type=script&lang=js&"
export * from "./IncludeDeletedClassificationsToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports